const doc = [({"zh_tw":({"adminComponentCompanyInvoice":({"companyInvoiceIndexTitle":"發票清單"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;